import { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import { defaultTitle, tokenKeyName } from "../../config";
// import { constants } from "../../config.json";
import * as constants from "../../constants";
import { useParams, useLocation, useHistory } from "react-router-dom";
import handleApiError from "../../helpers/handleApiError";
import { format as dateFormat } from "date-fns";
import {
  getOrderDetails,
  getOrderDetailsOld,
} from "../../services/deliveryService";
import { GleamPanel } from "../Utility/GleamPanel";
import { BsArrowClockwise } from "react-icons/bs";
import { OrderActionCenterDetailsDisplay } from "./OrderActionCenterDetailsDisplay";
import { OrderActionCenterForm } from "./OrderActionCenterForm";
import { getProfileInformation, isClient } from "../../services/accountService";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";

import { dateAfterDeliveryDate } from "../../helpers/utilities";
import {
  canFileClaim,
  canInitiateCODResearch,
  canRequestReturn,
  canSubmitDeliveryConcern,
} from "../../helpers/orderActionsUtilities";
import { Modal } from "react-bootstrap";
import Checkbox from "../Checkbox";
import { ClaimsFileUploadNotice } from "./ClaimsFileUploadNotice";
import { useQuery } from "@tanstack/react-query";

const viewStates = {
  success: "success",
  loading: "loading",
  error: "error",
  nodata: "nodata",
};
// const modes = {
//   deliveryconcern: "Create a New Delivery Concern",
//   codResearch: "Initiate Cod Research",
//   claim: "Create a New Claim",
//   return: "Request a Return",
// };

const modeTitles = constants.ActionCenterModes;

// const deliveryConcernModes = {
//   deliveryConcern: "deliveryConcern",
//   codResearch: "codResearch",
// };
export const OrderActionCenter = ({ setLoading }) => {
  const { action, deliveryId } = useParams(); //get delivery id from react-router match params
  // console.log(action);
  // console.log(deliveryId);
  // console.log(modeTitles[action.toLowerCase()]);
  const { search } = useLocation();
  const history = useHistory();
  const [currentMode, setCurrentMode] = useState(
    modeTitles[action.toLowerCase()] //the action is the part after actioncenter/ in the url, since the user could potentially write the url in any case they wanted, just lowercase it and keep the action center modes/modetitles object in all lower case
  );
  const [viewState, setViewState] = useState(viewStates.loading); //Right now, I think it's prob best to start off as loading,
  //to make sure we don't try to render anything that needs data when we don't have it
  // const [orderInfo, setOrderInfo] = useState();
  const [profileInfo, setProfileInfo] = useState();
  const [clientJWTInfo, setClientJWTInfo] = useState({});
  const [shouldFetchData, setShouldFetchData] = useState(false);

  useEffect(() => {
    //if customer (client's customer who should only be able to file returns) tries to go to an action center page they don't have access to

    if (
      !isClient() &&
      !(
        currentMode === constants.ActionCenterModes.return ||
        currentMode === constants.ActionCenterModes.manualreturn
      )
    ) {
      history.push("/not-found");
    }

    // if client tries to go to an action center page they don't have access to Manual Return
    if (
      isClient() &&
      currentMode === constants.ActionCenterModes.manualreturn
    ) {
      // console.log("kicking out 2");
      history.push("/not-found");
    }

    //if the user tries to go an action center page that does not exist, redirect them to /not-found
    // console.log(currentMode);
    if (!currentMode) {
      history.push("/not-found");
      // console.log("should kick me out");
    }
    setShouldFetchData(true);
    const fetchData = async () => {
      // setLoading(true);
      setViewState(viewStates.loading);

      //want to handle error here
      try {
        //No profile information route right now for a customer making a return on the customer portal but we don't need it
        if (isClient()) {
          const profileResponse = await getProfileInformation();
          setProfileInfo(profileResponse.data);
        } else {
          setProfileInfo({});
        }

        setClientJWTInfo(jwtDecode(localStorage.getItem(tokenKeyName)));

        //this was using the order details route that we use for the order details panel
        // const response = await getOrderDetails(
        //   deliveryId,
        //   invoiceNumber,
        //   formattedCreationDate,
        // isClient()
        // );
        // console.log("new route");
        // console.log(response);
        // console.log("end new route");
        // const filteredResponseData = response.data.filter((element) => {
        //   return element.cxtOrderTypeName !== "Delivery";
        // })[0];
        // console.log(filteredResponseData);
        // if (filteredResponseData?.deliveryInfo) {
        //   setOrderInfo(filteredResponseData.deliveryInfo);
        //   // setOrderInfo({ ...responseData.deliveryInfo, isCod: true });
        //   setCodResearchFormData({
        //     customerName: filteredResponseData.deliveryInfo.customerName,
        //     date: dateFormat(
        //       new Date(filteredResponseData.deliveryInfo.creationDate),
        //       "MM/dd/yyyy"
        //     ), //not sure if this the right date ***** LOOK INTO*******
        //     codAmount: filteredResponseData.deliveryInfo.codAmount,
        //   });
        // }
        setViewState(viewStates.success);
        // setLoading(false);
      } catch (ex) {
        if (ex.message === "Action Not Supported") {
          // setLoading(false);
        } else {
          // setLoading(false);
          setViewState(viewStates.error);
          handleApiError(ex, history);
        }
        // console.log(ex);
      }
    };
    fetchData();
  }, [deliveryId, search, setLoading]);

  const isClientMemo = useMemo(() => isClient(), []);
  const {
    data: orderInfo,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["orderDetailsOld", deliveryId],
    enabled: shouldFetchData,
    queryFn: async () => {
      const response = await getOrderDetailsOld(deliveryId, isClientMemo);
      if (typeof response.data === "string") {
        // console.log(response);
        throw new Error(response.data);
      }
      // return Promise.reject(new Error("hi"));
      return response;
    },
    select: (response) => {
      const deliveryInfo = response.data[0].deliveryInfo;
      if (currentMode === constants.ActionCenterModes.deliveryconcern) {
        const { ableTo, reason } = canSubmitDeliveryConcern(
          deliveryInfo.csrtrn
        );
        if (!ableTo) {
          history.push(constants.pages.orderHistory.url);
          toast.warning(reason);
          throw new Error("Action Not Supported");
        }
      } else if (currentMode === constants.ActionCenterModes.codresearch) {
        //COD research is only allowed if the order is a COD order (only regular orders can be COD orders as of now 12-20-2023), there is a scan AND it is after the delivery date(or there is a delivery scan)
        const { ableTo, reason } = canInitiateCODResearch(
          deliveryInfo.status,
          new Date(deliveryInfo.deliveryDate),
          deliveryInfo.isCod
        );
        if (!ableTo) {
          history.push(constants.pages.orderHistory.url);
          toast.warning(reason);
          throw new Error("Action Not Supported");
        }
      } else if (currentMode === constants.ActionCenterModes.claim) {
        const { ableTo, reason } = canFileClaim(
          deliveryInfo.status,
          deliveryInfo.clmtrn
        );
        if (!ableTo) {
          history.push(constants.pages.orderHistory.url);
          toast.warning(reason);
          throw new Error("Action Not Supported");
        }
      } else if (
        currentMode === constants.ActionCenterModes.return ||
        currentMode === constants.ActionCenterModes.manualreturn
      ) {
        const { ableTo, reason } = canRequestReturn(
          deliveryInfo.status,
          deliveryInfo.deliveryType
          // deliveryInfo.rtntrn
        );
        if (!ableTo) {
          history.push(constants.pages.orderHistory.url);
          toast.warning(reason);
          throw new Error("Action Not Supported");
        }
      }

      let finalOrderDetails = response.data[0].deliveryInfo;
      finalOrderDetails.codDetails = response.data[0].codDetails;
      return finalOrderDetails;
    },
    retry: 1,
    retryDelay: 3000,
  });

  // console.log("React Query - order details", orderInfo);
  // console.log("React Query - is fetching", isFetching);
  // console.log("React Query - error", error);
  useEffect(() => {
    if (error) {
      handleApiError(error, history);
    }
  }, [error]);

  const renderDecider = () => {
    if (viewState === viewStates.loading || isLoading) {
      return (
        <>
          <GleamPanel height="120px" className="paper-panel-always sub-panel" />
          <GleamPanel height="200px" className="paper-panel-always sub-panel" />
          <GleamPanel height="300px" className="paper-panel-always sub-panel" />
        </>
      );
    }
    if (viewState === viewStates.error || error) {
      return (
        <div
          // style={{
          //   position: "absolute",
          //   top: "0",
          //   left: "0",
          //   right: "0",
          //   bottom: "0",
          //   display: "grid",
          //   placeContent: "center",
          //   textAlign: "center",
          // }}
          style={{
            paddingTop: "300px",
            paddingBottom: "300px",
            textAlign: "center",
          }}
        >
          There was an issue processing your request. Please try refreshing the
          page.
          <br />
          <button
            onClick={() => {
              window.location.reload();
            }}
            style={{
              outline: "none",
              border: "none",
              margin: "10px",
              backgroundColor: "transparent",
              fontSize: "1.5rem",
            }}
          >
            <BsArrowClockwise />
          </button>
        </div>
      );
    }
    if (viewState === viewStates.success) {
      return (
        <>
          <OrderActionCenterDetailsDisplay orderInfo={orderInfo} />
          <OrderActionCenterForm
            mode={currentMode}
            setMode={setCurrentMode}
            orderInfo={orderInfo}
            profileInfo={profileInfo}
            clientJWTInfo={clientJWTInfo}
            history={history}
            setLoading={setLoading}
          />
        </>
      );
    }
    if (viewState === viewStates.nodata) {
      //doesn't occur currently
      return (
        <div
          // style={{
          //   position: "absolute",
          //   top: "0",
          //   left: "0",
          //   right: "0",
          //   bottom: "0",
          //   display: "grid",
          //   placeContent: "center",
          //   textAlign: "center",
          // }}
          style={{
            paddingTop: "300px",
            paddingBottom: "300px",
            textAlign: "center",
          }}
        >
          There was an issue processing your request. Please try refreshing the
          page.
          <br />
          <button
            onClick={() => {
              window.location.reload();
            }}
            style={{
              outline: "none",
              border: "none",
              margin: "10px",
              backgroundColor: "transparent",
              fontSize: "1.5rem",
            }}
          >
            <BsArrowClockwise />
          </button>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      {viewState === viewStates.success &&
        currentMode === constants.ActionCenterModes.claim && (
          <ClaimsFileUploadNotice />
        )}
      <Helmet>
        <title>
          {/* if user tries to visit action center with an invalid :action, the page will break unless we ad the ?? "".  */}
          {currentMode ?? ""} - {defaultTitle}
        </title>
      </Helmet>
      <div className="container paper-panel form-container">
        <div className="row">
          <div className="col form-header">
            <h1>Order Action Center</h1>
            <p>
              <span className="required-star">*</span> denotes a required field.
            </p>
          </div>
        </div>
        {renderDecider()}
      </div>
    </>
  );
};
